<template>
  <div
    v-for="(studentsList, groupTitle) in studentsListByGroup"
    :key="groupTitle"
  >
    <h2 class="text-gray-500 text-xs font-medium uppercase tracking-wide">
      {{ groupTitle }} ({{ studentsList.length }})
    </h2>
    <ul class="mt-3 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-3">
      <Student
        v-for="student in studentsList"
        :key="student.email"
        :student="student"
      />
    </ul>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
// eslint-disable-next-line no-unused-vars
import { GroupKey, groups, students } from '@/config'
import { useGroupParam, useSearchParam } from '@/hooks/app'
import { searchFor } from '@/utils'
import { groupBy } from 'ramda'
import Student from '@/components/Student.vue'

export default defineComponent({
  name: 'Students',
  components: { Student },
  setup() {
    const group = useGroupParam()

    const search = useSearchParam()

    const studentsList = computed(() => students.filter((student) => (
      (!group.value || group.value === student.group)
      && search.value.split(' ').every((word) => {
        const searchWord = searchFor(word)

        return searchWord(student.firstName) || searchWord(student.lastName)
      })
    )))

    const getGroupTitle = (groupKey: GroupKey) => groups.find(({ key }) => groupKey === key)!.title

    const studentsListByGroup = computed(() => groupBy((student) => getGroupTitle(student.group), studentsList.value))

    return {
      studentsList,
      studentsListByGroup,
    }
  },
})
</script>
